import Backbone from 'backbone'
import XhrStream from 'buffered-xhr-stream'
import errors from 'scoreboard/components/setup-errors'
import appDisplay from 'scoreboard/components/app-display'
import ErrorView from 'scoreboard/components/error-view'
import _ from 'lodash'
import { XHR_HEADERS_AVAILABLE } from 'scoreboard/components/permissions'

// if for some reason setupXhrStream is called more than once, this will ensure
// we don't have extra layers of method calls that aren't required
var handle = XhrStream.prototype.handle

// An aborted XHR will have this status
const UNSENT_STATUS = 0

function setupXhrStream() {
	XhrStream.prototype.handle = function() {
		if (this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
			Backbone.trigger(XHR_HEADERS_AVAILABLE, this.xhr)
			this.emit('headers', parseHeaders(this.xhr.getAllResponseHeaders()))
		}
		const {status} = this.xhr
		const unsuccessful = status != UNSENT_STATUS && status != 200
		if (this.xhr.readyState === XMLHttpRequest.DONE && unsuccessful) {
			var responseJSON = this.xhr.responseJSON
			var handled = errors.expiredLoginHandler(this.xhr)
			if (handled) {
				return
			}
			// there's 1 error handler built into node
			if (this.listeners('error').length <= 1) {
				appDisplay.dialog(new ErrorView(errors.errorViewOptions(this.xhr.status, responseJSON)))
			}
		}

		if (this.xhr.readyState === XMLHttpRequest.DONE && this.xhr.aborted) {
			return	//prevent unnecessary errors being generated on aborted requests already done
		}

		// if we reach here, proceed with normal behavior
		handle.apply(this, arguments)
	}
}

function parseHeaders (headersText) {
	return _.fromPairs(headersText.split('\n')
		        .map(function (h) {
		          return [ h.substring(0, h.indexOf(':')).trim().toLowerCase(),
		            h.substring(h.indexOf(':') + 1).trim() ]
		        })
		        .filter(function (h) { return !!h[0].trim() }))
}

export default setupXhrStream
export { parseHeaders }

setupXhrStream.__filename__ = 'setup-xhr-stream.js'
